module.exports = __webpack_public_path__ + "static/media/birthday-icon.d4563541.png";